import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button, Message } from "simplydo/react/ui";

import { useAppSelector } from "store";

import AppStyledDashboard from "components/AppStyledDashboard";
import Login from "components/entry/Login";
import PointOfContactList from "components/lib/PointOfContactList";

type PageLoadErrorProps = { title: React.ReactNode; message?: React.ReactNode };

function PageLoadError({ title, message }: PageLoadErrorProps) {
  const user = useAppSelector((state) => state.user);
  const { t } = useTranslation();

  return (
    <AppStyledDashboard
      excludeWelcomeText
      scrolling={false}
      padded="very"
      content={
        <>
          <Message style={{ textAlign: "center", marginBottom: 32 }}>
            <Message.Header>{title}</Message.Header>
            {user ?
              <Message.Content>{message}</Message.Content>
            : <Message.Content>
                {t("entry.login.useFormToLogIn")}
              </Message.Content>
            }
          </Message>

          {user && <PointOfContactList />}

          {!user ?
            <Login embedded />
          : <div style={{ textAlign: "center", marginTop: 36 }}>
              <Button as={Link} to="/" primary>
                Return to homepage
              </Button>
            </div>
          }
        </>
      }
    />
  );
}

export default PageLoadError;
